<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { InvitationAcceptPanel, useAcceptInvitation } from '@/features/membership'

const { t } = useI18n()
const route = useRoute()
const acceptance = useAcceptInvitation()

const token = route.params['token'] as string
</script>

<template>
  <main class="mx-auto flex max-w-[40rem] flex-col gap-6 p-8">
    <h1 class="text-[length:var(--text-step-7)] font-semibold text-[color:var(--color-text)]">
      {{ t('invitationAccept.title') }}
    </h1>

    <InvitationAcceptPanel
      :is-accepting="acceptance.isAccepting.value"
      :error="acceptance.error.value"
      :membership="acceptance.membership.value"
      @accept="acceptance.accept(token)"
    />
  </main>
</template>
